export enum RequestTypeEnum {
    Login = 'login',
    LoginByCode = 'login-by-code',
    ForgotPassword = 'forgot-password',

    AudioData = 'audio-data',

    FileUpload = 'file-upload',
    FileDownload = 'file-download',
    FileDelete = 'file-delete',

    CorrectionList = 'correction-list',
    CorrectionListAddWord = 'correction-list-add-word',
    CorrectionListDeleteWord = 'correction-list-delete-word',

    ExamCheckAccessCode = 'exam-check-access-code',
    ExamCheckUnlockCode = 'exam-check-unlock-code',
    ExamCreate = 'exam-create',
    ExamDownloadFile = 'exam-download-file',
    ExamExtend = 'exam-extend',
    ExamGetById = 'exam-get-by-id',
    ExamList = 'exam-list',
    ExamStudents = 'exam-students',
    ExamSaveFiles = 'exam-save-files',
    ExamSubmit = 'exam-submit',
    CancelExam = 'exam-cancel',
    ExamCalendarEvents = 'exam-calendar-events',

    FeatureRestrictionTemplate = 'feature-restriction-template',
    FeatureRestrictionTemplateAdd = 'feature-restriction-template-add',
    FeatureRestrictionTemplateDelete = 'feature-restriction-template-delete',
    FeatureRestrictionTemplateList = 'feature-restriction-template-list',
    FeatureRestrictionTemplateUpdate = 'feature-restriction-template-update',

    WolandOneDriveRequestToken = 'woland-one-drive-request-token',
}
